<template>
  <CCard class="c-time-progress-progress-bar">
    {{ $t('timeRegistrationModal.workedTime') }}
    <CProgressBar :current="timeRegistrationContainer.registeredMinutes" :max="timeRegistrationContainer.allowedMinutes"
                  class="u-mt-1" :class="{'c-time-progress-progress-bar-exceeded' : timeExceeded}"/>
    <CShelf class="u-mt-4">
      <template #left>
        <CColor :theme="timeExceeded ? 'danger' : 'success'">
          {{ durationFromMinutes(timeRegistrationContainer.registeredMinutes) }}
          <span v-if="timeUnitQuantity">
            {{ $t('timeRegistrationModal.timeUnit', { timeUnit: timeUnitQuantity }) }}
          </span>
        </CColor>
      </template>

      <template #right>
        {{ durationFromMinutes(timeRegistrationContainer.allowedMinutes) }}
      </template>
    </CShelf>
  </CCard>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CCard from '@/shared/components/CCard.vue';
  import CColor from '@/shared/components/CColor.vue';
  import CProgressBar from '@/shared/components/CProgressBar.vue';
  import CShelf from '@/shared/components/CShelf.vue';
  import { durationFromMinutes } from '@/shared/utils/dateTime';
  import TimeRegistrationContainer from '../../models/TimeRegistrationContainer';

  const props = defineProps<{
    timeRegistrationContainer: TimeRegistrationContainer,
  }>();

  const timeExceeded = computed(() => {
    if (props.timeRegistrationContainer.registeredMinutes && props.timeRegistrationContainer.allowedMinutes) {
      return props.timeRegistrationContainer.registeredMinutes > props.timeRegistrationContainer.allowedMinutes;
    }
  });

  const timeUnitQuantity = computed(() => {
    if (props.timeRegistrationContainer.registeredMinutes && props.timeRegistrationContainer.minutesPerUnit) {
      return Math.round(props.timeRegistrationContainer.registeredMinutes / props.timeRegistrationContainer.minutesPerUnit);
    }
  });
</script>

<style lang="scss">
  .c-time-progress-progress-bar {
    &-exceeded {
      .c-progress-bar-loaded {
        background: $danger;
      }
    }
  }
</style>